import router from './router'
import useRobotsTxtStore from './store'
import RobotsTxtMessages from './localization'

export default {
  router,
  useRobotsTxtStore,
  localization: RobotsTxtMessages,
}
